// WordCounter.tsx
import React, { useState, useMemo } from 'react';
import { Container, Card, Form, Row, Col, Button } from 'react-bootstrap';
import { Clipboard, Trash } from 'react-bootstrap-icons';
const WordCounter = () => {
    const [text, setText] = useState('');
    // Derived statistics
    const stats = useMemo(() => {
        const charCount = text.length;
        const wordCount = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
        const lineCount = text === '' ? 0 : text.split(/\r?\n/).length;
        const bytes = new Blob([text]).size;
        const sizeKB = (bytes / 1024).toFixed(2);
        // Rough page estimation: 1 page ≈ 300 words
        const pageCount = Math.max(1, Math.ceil(wordCount / 300));
        return { charCount, wordCount, lineCount, pageCount, sizeKB };
    }, [text]);
    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(text);
        }
        catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };
    const handleClear = () => {
        setText('');
    };
    return (React.createElement(Container, { className: "py-4" },
        React.createElement(Card, null,
            React.createElement(Card.Header, { as: "h4", className: "d-flex justify-content-between align-items-center" },
                React.createElement("span", { className: "flex-grow-1 text-center" }, "Real-Time Word Counter"),
                React.createElement("div", { className: "d-flex gap-2" },
                    React.createElement(Button, { variant: "outline-secondary", size: "sm", onClick: handleCopy, title: "Copy text" },
                        React.createElement(Clipboard, null)),
                    React.createElement(Button, { variant: "outline-danger", size: "sm", onClick: handleClear, title: "Clear text" },
                        React.createElement(Trash, null)))),
            React.createElement(Card.Body, null,
                React.createElement(Form.Group, { className: "mb-3" },
                    React.createElement(Form.Control, { as: "textarea", rows: 12, placeholder: "Paste or type your text here...", value: text, onChange: (e) => setText(e.target.value), style: { fontSize: '1rem', resize: 'vertical' } })),
                React.createElement(Row, { className: "g-3" },
                    React.createElement(Col, { xs: 6, sm: 4, md: 2 },
                        React.createElement(Card, { bg: "light", className: "text-center" },
                            React.createElement(Card.Body, null,
                                React.createElement("strong", null, "Characters"),
                                React.createElement("div", null, stats.charCount)))),
                    React.createElement(Col, { xs: 6, sm: 4, md: 2 },
                        React.createElement(Card, { bg: "light", className: "text-center" },
                            React.createElement(Card.Body, null,
                                React.createElement("strong", null, "Words"),
                                React.createElement("div", null, stats.wordCount)))),
                    React.createElement(Col, { xs: 6, sm: 4, md: 2 },
                        React.createElement(Card, { bg: "light", className: "text-center" },
                            React.createElement(Card.Body, null,
                                React.createElement("strong", null, "Lines"),
                                React.createElement("div", null, stats.lineCount)))),
                    React.createElement(Col, { xs: 6, sm: 4, md: 2 },
                        React.createElement(Card, { bg: "light", className: "text-center" },
                            React.createElement(Card.Body, null,
                                React.createElement("strong", null, "Pages"),
                                React.createElement("div", null, stats.pageCount)))),
                    React.createElement(Col, { xs: 6, sm: 4, md: 2 },
                        React.createElement(Card, { bg: "light", className: "text-center" },
                            React.createElement(Card.Body, null,
                                React.createElement("strong", null, "Size (KB)"),
                                React.createElement("div", null, stats.sizeKB)))))))));
};
export default WordCounter;
